module.exports = __webpack_public_path__ + "img/visualDesigns.cf967f71.png";